<template>
  <div>
    <base-header pageName="주소 검색" :popup="true"></base-header>

    <section id="wrap">
      <div class="search-input">
        <p>지번, 도로명, 건물명을 입력하세요.</p>
        <input
          type="search"
          v-model="keyword"
          ref="keyword"
          @keyup.enter="postSearch"
          placeholder="예) 을지로 51 또는 교원구몬빌딩"
        />
        <button
          type="button"
          class="search"
          title="검색"
          @click="postSearch"
        ></button>
      </div>
      <ul class="search-result-place" v-if="jusoList.length > 0">
        <li v-for="(juso, index) in jusoList" v-bind:key="index">
          <strong>{{ juso.bdNm }}</strong>
          <p>
            <em><i>도로명</i></em>
            <span>{{ juso.roadAddr }}</span>
            <em><i>지번</i></em>
            <span>{{ juso.jibunAddr }}</span>
          </p>
          <span class="radio">
            <input
              type="radio"
              name=""
              :id="index"
              @click="selectedJuso(index)"
            />
            <label :for="index"></label>
          </span>
        </li>
      </ul>
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="waveDots"
        ref="InfiniteLoading"
      >
        <div slot="no-more"></div>
        <div slot="no-results">
          <div class="search-resutl-None">
            <p>검색된 주소가 없습니다.<br />다시 검색해 주세요.</p>
          </div>
        </div>
      </infinite-loading>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "PostSearch",
  components: {
    InfiniteLoading
  },
  data() {
    return {
      keyword: "",
      tot: 0,
      currentPage: 0,
      countPerPage: 0,
      jusoList: []
    };
  },
  methods: {
    infiniteHandler: function($state) {
      console.log("SCROLL");
      console.log("this.currentPage:" + this.currentPage);
      var that = this;
      var parameters = {
        keyword: this.keyword,
        currentPage: this.currentPage,
        countPerPage: this.countPerPage
      };
      this.$api.commonPopup
        .postSearch(parameters)
        .then(function(res) {
          // console.log("PostSearch.vue <api.postSearch.postSearch.response> common.currentPage:",res.common.currentPage);
          // console.log("PostSearch.vue <api.postSearch.postSearch.response> :",res.juso);
          that.tot = res.common.totalCount;
          var list = res.juso;
          if (list.length) {
            that.currentPage += 1;
            that.jusoList = that.jusoList.concat(list);
            $state.loaded();
            if (list.length < that.countPerPage) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    postSearch: function() { // 주소조회
      this.tot = 0;
      this.currentPage = 1;
      this.countPerPage = 10;
      this.jusoList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    selectedJuso: function(index) { // 주소 선택시 부모창에 key 전달.
      var child = {
        name: "juso-selected",
        data: { 
                zipNo: this.jusoList[index].zipNo, // 우편번호
                bdNm: this.jusoList[index].bdNm, // 건물명
                siNm: this.jusoList[index].siNm, // 시도명
                sggNm: this.jusoList[index].sggNm, // 시군구명
                emdNm: this.jusoList[index].emdNm, // 읍면동명
                rn: this.jusoList[index].rn, // 도로명
                jibunAddr: this.jusoList[index].jibunAddr, // 지번주소
                roadAddr: this.jusoList[index].roadAddr, // 전체 도로명주소
              }
      };
      this.$utils.nativeIf.outbound.sendChildData(child);
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    this.$refs.keyword.focus();
  }
};
</script>
